export const getPeriodNumber = (periodKey: string | undefined): number | null => {
  const periodNumber = Number(periodKey?.replace(/^(MD|GW)/, '') ?? '');
  return Number.isFinite(periodNumber) ? periodNumber : null;
};
